module.exports = __webpack_public_path__ + "55a8316e5d4638ec9bb17c7e09203b6e.jpg";